
import axios from 'axios';
import { useState, useRef, useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import CardLeftHandSide from '../Components/CardLeftHandSide';
import CardRightHandSide from '../Components/CardRightHandSide';

import FaceIcon from '@mui/icons-material/Face';
import Face4Icon from '@mui/icons-material/Face4';

import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabView, TabPanel } from 'primereact/tabview';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Chip } from 'primereact/chip';
import { InputText } from 'primereact/inputtext';

import Masonry from 'react-masonry-css';
        
import { addManagerList2MemberList, addAssignList2MemberList, addNumber2MemberList, getChip, getFace, updateManagerSupervisorList, sortMemberList, isSelected, getServiceListItem } from '../Utilities/common';
import { DEBUG, API_BASE_URL_UAT, API_BASE_URL, BOOK_LIST } from '../Utilities/constant';

import mui from '../Imports/muiImports';
import reducer from '../Imports/reducerImports';
import component from '../Imports/componentImports';
import { useShared } from '../Utilities/allContext1';
import { setSupervisorList, setManagerList } from '../Redux/allReducer';

export default function Print(){

    const { setMemberList } = reducer;
    const { MemberTable, DataGrid1 } = component;  
    const { updateDBSupervisorList, updateDBManagerList, getAssignList, updateAssignList, getServiceList, getMemberList } = useShared();

    const dispatch = useDispatch(); // dispatch(
    const memberList = useSelector((state) => state.all.memberList);
    const managerList = useSelector((state) => state.all.managerList);
    const assignList = useSelector((state) => state.all.assignList);
    const serviceList = useSelector((state) => state.all.serviceList);

    const cardStyle = {
        margin: '5px 0px',
    };

    // Style for the flex container holding both sides
    const containerStyle = {
        display: 'flex',
        justifyContent: 'space-between', // Pushes left component to far left, right to far right
        alignItems: 'flex-start',       // Aligns them at the top
        gap: '0px'                     // Adds spacing between them so they don't crash if screen shrinks
    };

    // Optional styles for the children if you want them to occupy equal widths
    const sideStyle = {
        flex: 1 
    };

    const currentDate = () => {
        const today = new Date();
        return today.toLocaleDateString();
    };

    return (

        <div>
            沙　田　區　服　事　人　位　名　單（　列　印　日　期　：　{currentDate()}　）<br/><br/>

            <Masonry
                breakpointCols={{ default: 8, 1100: 3, 700: 2, 500: 1 }} // Adjust breakpoints as needed
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
            >
                {serviceList.map((service) => (
                    <Card style={cardStyle} title={<span style={{ fontSize: '16px', fontWeight: 'bold' }}>{service.name}</span>}>
                        <div style={containerStyle}>
                            <div style={sideStyle}>
                                <CardLeftHandSide serviceId={service.id}/>
                            </div>
                            <div style={sideStyle}>
                                <CardRightHandSide serviceId={service.id}/>
                            </div>
                        </div>
                    </Card>
                ))}
            </Masonry>
        </div>

    )
}